import styled from "styled-components";

export const Social = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  .share {
    display: flex;
    align-items: center;

    a {
      &:hover {
        transition: none;
      }
    }

    i {
      cursor: pointer;
      display: flex;
      align-content: center;

      &.facebook svg {
        fill: #1877f2;

        &:hover {
          fill: var(--primary);
        }
      }

      &.linkedin {
        width: 30px;
        height: 30px;

        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
`;
